import React from 'react';

export default function Loader({
    message = 'Loading...',
    showMessage = true,
    className = '',
    fullscreen = true,
}) {
    return (
        <div className={`loader-container ${fullscreen ? 'loader-fullscreen' : ''} ${className}`}>
            <div className="loader-content">
                <div className="loader-spinner">
                    <div className="loader-spinner-outer" />
                    <div className="loader-spinner-inner" />

                    <div className="loader-letters">
                        {'OBANA'.split('').map((letter, index) => (
                            <span
                                key={letter + index}
                                className="loader-letter"
                                style={{
                                    animationDelay: `${index * 0.1}s`,
                                }}>
                                {letter}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="loader-dots">
                    {[0, 1, 2].map((dot) => (
                        <div
                            key={dot}
                            className="loader-dot"
                            style={{
                                animationDelay: `${dot * 0.2}s`,
                            }}
                        />
                    ))}
                </div>

                {showMessage && <p className="loader-message">{message}</p>}
            </div>
        </div>
    );
}
